import { render, staticRenderFns } from "./standard.vue?vue&type=template&id=a3ff4968&"
import script from "./standard.vue?vue&type=script&lang=ts&"
export * from "./standard.vue?vue&type=script&lang=ts&"
import style0 from "./standard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DefaultPageHeader: require('/tmp/build_71ad00c4/src/components/layout/DefaultPageHeader.vue').default,LazyMount: require('/tmp/build_71ad00c4/src/components/misc/LazyMount.vue').default})
